<div class="progress-bar relative w-full text-primary-green">
  <div class="container mx-auto">
    <ng-template #progressOverview>
      <div class="progress-bar-inner-vertical grid">
        <div class="h-full">
          <ng-container *ngFor="let milestone of allMilestones; let j = index">
            <div class="grid grid-cols-[min-content_1fr]">
              <div class="grid grid-rows-[min-content_1fr]">
                <div
                  class="flex h-8 w-8 items-center justify-center rounded-full bg-primary-green"
                  [ngClass]="{'bg-gray-400 border-gray-400': true, 'bg-primary-green border-primary-green': currentMilestoneIndex >= j, 'scale-110' : currentMilestoneIndex === j}"
                >
                  <div
                    class="text-white"
                    *ngIf="j !== allMilestones.length - 1"
                  >
                    {{ j + 1 }}
                  </div>
                  <div
                    class="text-white"
                    *ngIf="j === allMilestones.length - 1"
                  >
                    <pax-icon [name]="lastMilestoneIcon.name"></pax-icon>
                  </div>
                </div>
                <div class="grid-rows-auto grid justify-center">
                  <ng-container
                    *ngFor="let step of milestone.steps; let i = index"
                  >
                    <div
                      *ngIf="i === 0"
                      [ngClass]="{'steps-rail bg-gray-400': true, 'bg-primary-green': currentMilestoneIndex > j || (currentMilestoneIndex === j && currentStepIndex >= i) }"
                    ></div>

                    <div
                      [ngClass]="{'steps-rail bg-gray-400': true, 'bg-primary-green': currentMilestoneIndex > j || (currentMilestoneIndex === j && currentStepIndex > i) }"
                    ></div>
                  </ng-container>
                </div>
              </div>
              <div class="ml-3">
                <h2 class="text-lg font-bold">{{milestone.title}}</h2>
                <p class="mb-3 text-sm">{{milestone.text}}</p>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-template>
    <div
      class="progress-bar-inner-horizontal grid h-14 w-full scale-50 items-center md:scale-75"
    >
      <div></div>
      <div
        class="flex flex-grow cursor-pointer flex-col justify-center text-center"
        (click)="showProgressOverview()"
      >
        <div class="relative inline-flex items-center">
          <ng-container
            *ngFor="let step of allMilestones[currentMilestoneIndex]?.steps; let i = index"
          >
            <div
              [title]="step.title"
              [ngClass]="{'steps-bullet relative flex rounded-full flex-shrink-0 justify-center w-4 h-4 bg-gray-400 border-gray-400': true, 'bg-primary-green border-primary-green': currentStepIndex >= i, 'scale-110' : currentStepIndex === i}"
            >
              <span class="sr-only">{{ step.title }}</span>
            </div>
            <div
              [ngClass]="{'steps-rail bg-gray-400': true, 'bg-primary-green': currentStepIndex > i}"
            ></div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
